module.exports = __webpack_public_path__ + "img/about1.c2802a94.jpg";